<template>
	<div class="day-views" v-if="getAllScenarios">
		<div class="day-views__headline mb-30 w-100 px-10">
			<c-title size="23" bg="ECECEC" color="111">
				{{ new Date() | moment('DD MMMM')}}
			</c-title>
			<div class="scenarios-select" :class="{opened: opened}">
				<div class="scenarios-select__arrow" @click="opened = !opened">
					<img src="@/assets/arrow.svg"/>
				</div>
				<div class="scenarios-select__selected" @click="opened = !opened">
					{{ getScenariosType }}
				</div>
				<div class="scenarios-select__list">
					<ul>
						<li v-for="(scenario, idx) in getAllScenarios.filter"
						    @click="selectType(scenario)"
						    :key="`menu-${idx}`">
							{{ scenario }}
						</li>
					</ul>
				</div>
			</div>
		</div>
		<div class="day-views__list">
			<a @click="linkHandler(scenario)"
			   class="day-views__list-item"
			   :class="{'done': isDone(scenario.hashId)}"
			   v-for="(scenario, idx) in current.scenarios"
			   :key="`menu-${idx}`">
				<div>
					{{ scenario.name }}
				</div>
				<img src="@/assets/arrow.svg"/>
			</a>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
	data() {
		return {
			opened: false,
			currentType: '',
			current: {},
		};
	},
	computed: {
		...mapGetters(['getScenarios', 'getAllScenarios', 'getUser', 'getScenariosType']),
	},
	async mounted() {
		await this.$store.dispatch('loadAllScenarios');
		this.makeList();
	},
	methods: {
		...mapMutations(['setScenariosType']),
		isDone(hashId) {
			try {
				return this.getAllScenarios.doneToday.find((el) => el === hashId);
			} catch (e) {
				return console.error(e);
			}
		},
		linkHandler(el) {
			this.$ga.event('Skaavok', 'Click on Scenario', el.name);
			if (el.settings && el.settings.length) {
				this.$store.dispatch('loadSettings', el.settings);
				this.$router.push({ name: 'DayViewSettings', params: { id: el.hashId } });
			} else {
				this.$router.push({ name: 'DayViewSingle', params: { id: el.hashId } });
			}
		},
		makeList() {
			const scenario = this.getAllScenarios.orders;
			this.current = scenario.find((el) => el.name === this.getScenariosType);
		},
		selectType(scenario) {
			this.setScenariosType(scenario);
			this.opened = false;
		},
	},
	watch: {
		getScenariosType() {
			this.makeList();
		},
	},
};
</script>

<style lang="scss">
	.day-views {
		padding: 80px 0 20px;

		&__headline {
			display: flex;
			flex-direction: row;
			align-items: flex-start;
			justify-content: space-between;
		}

		&__list {
			display: flex;
			flex-direction: column;

			&-item {
				background: #EDEDED;
				display: flex;
				align-items: center;
				justify-content: space-between;
				padding: 15px 20px;
				font-size: 16px;
				font-weight: 800;
				margin-bottom: 5px;
				text-decoration: none;
				color: #111;
				cursor: pointer;

				&.done {
					background: #52FF00;
				}
			}
		}
	}

	.scenarios-select {
		display: flex;
		flex-direction: column;
		flex: 0 0 70%;
		font-family: 'Burbank Big Cd Bd', sans-serif;
		font-size: 22px;
		position: relative;
		cursor: pointer;

		&__arrow {
			position: absolute;
			z-index: 4;
			right: 15px;
			top: 16px;
			transform: rotate(90deg);
		}

		&__selected {
			background: #FFA800;
			clip-path: polygon(0 0, 100% 20%, 100% 100%, 0% 100%);
			padding: 15px 40px 5px 15px;
			white-space: nowrap;
		}

		&.opened {

			.scenarios-select__arrow {
				right: 10px;
				transform: rotate(-90deg);
			}

			.scenarios-select__list {
				max-height: 300px;
				height: auto;
			}
		}

		&__list {
			background: #FFA800;
			padding: 0 15px 0;
			position: absolute;
			top: 43px;
			width: 100%;
			clip-path: polygon(0 0, 100% 0, 100% 95%, 0% 100%);
			max-height: 0;

			ul {
				padding: 0;
				margin: 0;

				li {
					list-style: none;
					padding: 12px 0;
					border-top: 1px solid rgba(0, 0, 0, .4);
					cursor: pointer;
				}
			}
		}
	}
</style>
